const ErrorMessage = ({
  message
}) => {
  return <>
      {message && <span className="text-xs italic text-red-500">{message}</span>}
    </>;
};
export default ErrorMessage;